import {
  apiPutExercise,
  apiPutNutrition,
  apiPutUserProfile,
} from 'dataLayer/api/apiClient';
import {
  exerciseAtom,
  genotypeStatusAtom,
  nutritionAtom,
  userProfileAtom,
} from 'dataLayer/recoil/apiData/atoms';
import {
  basicWellnessInfoFormSubmitAtom,
  fitnessPreferencesFormSubmitAtom,
  nutritionPreferencesFormSubmitAtom,
  profileInfoAtom,
  profileInfoFormSubmitAtom,
} from 'dataLayer/recoil/pages/myProfile/atoms';
import { selector } from 'recoil';

export const myProfileCompleteDataGet = selector({
  key: 'apiData/pages/myProfile/selectors/myProfileCompleteData/get',
  get: ({ get }) => {
    get(userProfileAtom);
    get(profileInfoAtom);
    get(exerciseAtom);
    get(nutritionAtom);
    get(genotypeStatusAtom);
  },
});

export const profileInfoSelectorPut = selector({
  key: 'apiData/pages/myProfile/selectors/profileInfo/put',
  get: async ({ get }) => {
    let result = {};
    const profileInfo = get(profileInfoFormSubmitAtom);

    if (profileInfo) {
      result = await apiPutUserProfile(profileInfo);
    }

    return result;
  },
});

export const wellnessProfileSelectorPut = selector({
  key: 'apiData/pages/myProfile/selectors/wellnessProfile/put',
  get: ({ get }) => {
    let result = {};
    const basicWellnessInfo = get(basicWellnessInfoFormSubmitAtom);

    //TODO: check if this is right way to handle this. As selector is triggered on useRecoilValueLoadable() call, PUT method is triggered on screen load
    if (basicWellnessInfo) {
      result = apiPutUserProfile({ ...basicWellnessInfo });
    }

    return result;
  },
});

export const fitnessPreferencesSelectorPut = selector({
  key: 'apiData/pages/myProfile/selectors/fitnessPreferences/put',
  get: ({ get }) => {
    let result = {};
    const fitnessPreferencesForm = get(fitnessPreferencesFormSubmitAtom);

    let requestData = {};
    if (fitnessPreferencesForm) {
      fitnessPreferencesForm.forEach((element) => {
        requestData[element.name] = element.checked;
      });
      result = apiPutExercise(requestData);
    }

    return result;
  },
});

export const nutritionPreferencesSelectorPut = selector({
  key: 'apiData/pages/myProfile/selectors/nutritionPreferences/put',
  get: ({ get }) => {
    let result = {};
    const nutritionPreferencesForm = get(nutritionPreferencesFormSubmitAtom);

    let requestData = {};
    if (nutritionPreferencesForm) {
      nutritionPreferencesForm.forEach((element) => {
        requestData[element.name] = element.checked;
      });
      result = apiPutNutrition(requestData);
    }

    return result;
  },
});

export const genotypeDataSelector = selector({
  key: 'apiData/pages/myProfile/selectors/genotypeData',
  get: ({ get }) => {
    let result = {};
    return result;
  },
});
